import { useAuth } from "@/components/AuthProvider";
import { HUB_CACHE_CHANNEL, type HubCacheSseEvent } from "@/lib/hubCacheChannels";
import { useHubCacheStream } from "@/lib/useHubCacheStream";

export function useHubLaborPresenceStream(options: {
  enabled?: boolean;
  onPresenceChange: (event: HubCacheSseEvent) => void;
}): void {
  const { session } = useAuth();
  const userId = session?.user?.id;
  const channels = userId != null ? [HUB_CACHE_CHANNEL.hubLaborPresence(userId)] : [];

  useHubCacheStream({
    channels,
    enabled: options.enabled !== false && userId != null,
    onEvent: options.onPresenceChange,
  });
}

export function isHubLaborPresenceEvent(event: HubCacheSseEvent): boolean {
  return event.phase === "invalidated" && event.labor_reason != null;
}
